/*
    This file contains all the URLS belong to location management menu
*/

// Menu keys
import { MENU_KEYS } from "@Vytelle/admin/src/constants/ApplicationMenuConstants";

const KEY = MENU_KEYS.LOCATION;

// Location params
export const LOCATION_PARAMS = {
  LOCATION_ID: ":locationId",
};

export const LOCATION_URLS = {
  /* LOCATION URLS   */
  LOCATION_LIST: KEY + "/list", // Location Listing
  LOCATION_DETAIL: KEY + `/detail/${LOCATION_PARAMS.LOCATION_ID}`, // Location Detail
  LOCATION_ADD: KEY + "/add", // add location url
  LOCATION_UPDATE: KEY + `/update/${LOCATION_PARAMS.LOCATION_ID}`, // Location update
};
